import styled from 'styled-components'
import { rem } from 'polished'

interface BannerContentComponentProps {
  bannerDesktopURL: string
  bannerMobileURL: string
  ratio: number
}

export const BannerComponent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  width: 100%;
  max-width: ${rem(1920)};

  .swiper-container {
    margin: 0 ${rem(-44 - 64)};
    padding: 0;
    width: 100%;
  }

  .swiper-slide-container {
    width: auto;
    height: auto;
  }
`

export const BannerContentComponent = styled.div<BannerContentComponentProps>`
  background-image: url(${(props) => props.bannerDesktopURL});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  aspect-ratio: ${(props) => props.ratio};
  width: 100%;

  @supports not (aspect-ratio: 1440 / 480) {
    height: ${rem(480)};
  }

  @media (max-width: 559.5px) {
    background-image: url(${(props) => props.bannerMobileURL});
    aspect-ratio: 360 / 320;

    @supports not (aspect-ratio: 360 / 320) {
      height: ${rem(320)};
    }
  }
`
